import Modal from 'react-bootstrap/Modal'

interface IModalProps {
    show: boolean
    onHide: () => void
    setChecked: React.Dispatch<
        React.SetStateAction<{
            [key: string]: boolean
        }>
    >
    checked: {
        [key: string]: boolean
    }
    setIsOpenMyWalletModal: React.Dispatch<React.SetStateAction<boolean>>
    setIsOnceOpenCard: React.Dispatch<React.SetStateAction<boolean>>
}
const ManagerAccountModal = ({
    show,
    onHide,
    setChecked,
    checked,
    setIsOpenMyWalletModal,
    setIsOnceOpenCard,
}: IModalProps) => {
    return (
        <Modal
            show={show}
            onHide={onHide}
            size="sm"
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            <div className=" p-2">
                <p className=" text-[#3C3C3B] px-2 mb-2 mt-4">
                    مبالغ واریزی به صندوق تا قبل از ساعت 21:30 روزهای کاری،
                    فردای آن روز بین ساعات 16 تا 18 به حساب متصل به صندوق واریز
                    می شود.
                </p>
                <hr className=" my-2" />
                <p
                    className=" text-green-1 text-center my-3"
                    onClick={() => {
                        onHide()
                        setIsOpenMyWalletModal(true)
                        setIsOnceOpenCard(true)
                    }}
                >
                    متوجه شدم
                </p>
                <hr className=" my-2" />
                <p
                    onClick={() => {
                        setChecked({ ...checked, isManagerAccount: false })
                        onHide()
                    }}
                    className="text-center my-3"
                >
                    انصراف
                </p>
            </div>
        </Modal>
    )
}

export default ManagerAccountModal
